import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { calculateAverageStars } from "src/utils/calculateAverageStar";
import { Star } from "../assets/icons/icons";
import { ProgressBar } from "./components/progress-bar";

export const Stats = ({ reviews }) => {
  const { t } = useTranslation();

  // Отзывы-скриншоты оценки не несут — в разбивке по звёздам им не место.
  // Пока таких отзывов большинство, гистограмма из пустых полос говорила бы
  // о компании неправду, поэтому весь блок с рейтингом показываем, только
  // когда есть что показывать.
  const rated = reviews.filter((review) => Number(review.stars) > 0);
  const average = calculateAverageStars(reviews);

  const counts = [5, 4, 3, 2, 1].map((rating) => ({
    rating,
    count: rated.filter((review) => Number(review.stars) === rating).length,
  }));

  return (
    <div className="lg:col-span-4">
      <div className="mt-3 flex items-center">
        {rated.length > 0 && (
          <div className="flex items-center">
            {[0, 1, 2, 3, 4].map((rating, index) => (
              <Star
                key={index}
                className={clsx(
                  average > rating ? "fill-kj-gold" : "fill-neutral-600",
                  "h-6 w-6 flex-shrink-0"
                )}
              />
            ))}
          </div>
        )}
        <p className={clsx("text-sm text-kj-ink", rated.length > 0 && "ml-2")}>
          {t("reviews.basedOn")} {reviews.length} {t("reviews.reviews")}
        </p>
      </div>

      {rated.length > 0 && (
        <div className="mt-6">
          <dl className="space-y-3">
            {counts.map((count, index) => (
              <ProgressBar key={index} count={count} reviews={rated} />
            ))}
          </dl>
        </div>
      )}

      <div className="mt-10">
        <h3 className="text-lg font-bold uppercase tracking-tight text-kj-ink">
          {t("reviews.thoughtsText")}
        </h3>
        <p className="mt-1 text-base text-kj-sub leading-relaxed">
          {t("reviews.thoughtsSubText")}
        </p>
        <Link
          to="/write-review"
          className="mt-6 inline-flex w-full bg-transparent border border-kj-gold text-kj-gold rounded-sm py-2.5 px-8 items-center justify-center text-xs font-bold uppercase tracking-[0.1em] hover:bg-kj-gold hover:text-kj-dark transition-colors sm:w-auto lg:w-full"
        >
          {t("reviews.btnText")}
        </Link>
      </div>
    </div>
  );
};
